<template>
  <div>
    <vx-card class="mb-base" style="margin-top: 20px;">
      <div class="flex items-center mb-5">
        <h2 class="mb-0">Activities</h2>
      </div>
      <div class="overflow-auto">
        <table class="table learning-activity-table" width="100%">
          <thead>
            <tr>
              <th>Activity</th>
              <th>Description</th>
              <th class="text-center">Core Skill</th>
              <th class="text-center">Ways of Learning</th>
              <th class="text-center">STREAM</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{{ activity.name }}</th>
              <td>{{ activity.description }}</td>
              <td class="text-center">
                <img
                  v-if="activity.coreSkills"
                  :src="
                    activity.coreSkills[0].icon
                      ? activity.coreSkills[0].icon
                      : $defaultImage
                  "
                  alt
                  class="inline-block h-12 object-contain"
                />
                <p>
                  {{ activity.coreSkills ? activity.coreSkills[0].name : "" }}
                </p>
              </td>
              <td class="text-center">
                <img
                  v-if="activity.waysOfLearnings"
                  :src="
                    activity.waysOfLearnings[0].icon
                      ? activity.waysOfLearnings[0].icon
                      : $defaultImage
                  "
                  alt
                  class="inline-block h-12 object-contain"
                />
                <p>
                  {{
                    activity.waysOfLearnings
                      ? activity.waysOfLearnings[0].name
                      : ""
                  }}
                </p>
              </td>
              <td class="text-center">
                <img
                  v-if="activity.streams"
                  :src="
                    activity.streams[0].icon
                      ? activity.streams[0].icon
                      : $defaultImage
                  "
                  alt
                  class="inline-block h-12 object-contain"
                />
                <p>{{ activity.streams ? activity.streams[0].name : "" }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </vx-card>

    <!--Purpose Statement-->
    <vx-card class="mb-base">
      <h2>Play with Purpose. (Your Intentionality)</h2>
      <vs-textarea
        :class="purposeStatement ? 'hasValue' : ''"
        :label="'Play with purpose statement'"
        v-model="purposeStatement"
        :disabled="true"
        style="font-size: 16px; line-height: 23px; border: 1px solid #d8d8d8;"
      />
    </vx-card>

    <vs-row style="align-items: stretch; width: 100%;">
        <vx-card class="photo-wrapper" style="flex: 1; display: flex; flex-direction: column;">
          <h2>Photos and Videos</h2>
          <ul class="photos-list">
            <li
              class="photo-item"
              v-for="(image, index) in imageVideos"
              :key="index"
              style="display: inline-block"
            >
              <img
                v-if="hasAllowedVideoExtension(image.src)"
                @click="openGallery(image, index)"
                :src="convertVideoFileExtenion(image.src)"
              />
              <img
                v-if="hasAllowedVideoExtension(image.src)"
                class="playButton"
                style="max-height: 45px"
                @click="openGallery(image, index)"
                src="https://personhood.s3.ap-southeast-2.amazonaws.com/undefined/play-button-svgrepo-com.svg"
              />

              <img
                v-else
                v-lazy="image.src || image.thumb"
                style="height: 100px"
                @click="openGallery(image, index)"
              />
            </li>
          </ul>
          <LightBox
            v-if="this.openLightBox"
            ref="lightbox"
            :media="lightboxMediaSource"
            :show-light-box="false"
            :show-caption="false"
            :show-thumbs="false"
            @onImageChanged="onImageChanged"
          />
        </vx-card>
    </vs-row>

    <!--EYLF Checklist-->
    <vx-card class="mb-base eylf-card">
      <div class="flex mb-5">
        <vs-button class="ml-auto" @click="expandCollapseAll">
          {{ collapsed ? "Expand " : "Collapse " }} all</vs-button
        >
      </div>
      <vs-row>
        <vs-col
          vs-lg="4"
          vs-sm="12"
          vs-xs="12"
          class="eylf-col px-0 md:pl-5 md:pr-10 border-b-0 mb-5 md:mb-0"
          v-for="(category, key) in eylfCategories"
          :key="key"
        >
          <h2>Learning Framework {{ category.title }}</h2>
          <vs-collapse class="p-0">
            <template v-for="(list, index) in category.eylfChecklists">
              <div class="flex align-self-start mb-5" :key="index">
                <vs-checkbox
                  :disabled="true"
                  v-model="selectedChecklist"
                  :vs-value="list._id"
                ></vs-checkbox>
                <collapse
                  ref="collapsible"
                  :key="index"
                  :collapse="collapsed"
                  :data="list"
                ></collapse>
              </div>
            </template>
          </vs-collapse>
        </vs-col>
      </vs-row>
    </vx-card>

    <!--Children-->
    <vs-row style="align-items: stretch; width: 100%;">
      <vs-col vs-w="8" style="display: flex; flex-direction: column;">
        <vx-card class="mb-base" style="flex: 1; display: flex; flex-direction: column; padding-bottom: 20px;">
          <h2>Children</h2>
          <vs-row>
            <vs-col vs-type="flex" style="position: relative; min-height: 60px;">
              <template>
                <ul class="teacher-list w-full">
                  <li
                    v-for="(child, key) in children"
                    :class="key === activeChildIndex ? 'active' : ''"
                    @click="selectChildToUpdate(child, key)"
                    style="vertical-align: top"
                    :key="key + 0.3"
                  >
                    <vs-avatar size="large" :src="child.photo" />
                    <h3
                      class="h5"
                      style="color: #289AD5; font-size: 14px; line-height: 18px;"
                    >
                      {{ child.name }}
                    </h3>
                  </li>
                </ul>
              </template>
            </vs-col>
          </vs-row>
        </vx-card>
      </vs-col>
      
      <!-- Documents Card: 1/3 width -->
      <vs-col vs-w="4" style="display: flex; flex-direction: column;">
        <vx-card class="mb-base" style="flex: 1; display: flex; flex-direction: column; padding-bottom: 20px;">
          <h2>Documents</h2>
            <ul class="photos-list" :style="{
              display: 'flex',
              flexDirection: 'row',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              gap: '10px',
              listStyle: 'none',
              paddingTop: documents.length > 0 ? '20px' : '0px',
              height: documents.length > 0 ? '170px' : '0px'
            }">
              <li
                class="photo-item"
                v-for="(document, index) in documents"
                :key="index"
                style="
                  display: inline-block;
                  position: relative;
                  width: 130px;
                  box-sizing: border-box;
                  background: #fff;
                "
              >
                <a
                  :href="document.src"
                  target="_blank"
                  style="display: flex; flex-direction: column; align-items: center; justify-content: flex-start; text-align: center;"
                >
                  <img
                    :src="getIcon(document.extension)"
                    alt="Document Icon"
                    style="width: 100px; height: 100px; margin-top: 10px;"
                  />

                  <div
                    style="
                      max-width: 100%;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      font-size: 10px;
                      margin-top: 5px;
                      padding: 0 5px;
                    "
                  >
                    {{ document.title ? document.title : document.extension.toUpperCase() }}
                  </div>
                </a>
              </li>
          </ul>
        </vx-card>
      </vs-col>      
    </vs-row>

    <vx-card class="mb-base" v-if="children.length">
      <h3 class="h2 mb-4">
        How has {{ children[activeChildIndex].name }} changed? (Assessment of
        Learning)
      </h3>
      <vs-row class="textarea1">
        <vs-col
          :class="children[activeChildIndex].howHasChanged ? 'hasValue' : ''"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="8"
          vs-sm="12"
          vs-xs="12"
          style="margin-bottom: 15px;"
        >
          <vs-textarea
            :label="'How has ' + children[activeChildIndex].name + ' changed'"
            v-model="children[activeChildIndex].howHasChanged"
            :disabled="true"
          />
        </vs-col>
      </vs-row>
      <vs-row class="mb-6 textarea2">
        <vs-col
          :class="
            children[activeChildIndex].coreSkillReflection ? 'hasValue' : ''
          "
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="6"
          vs-xs="12"
          class="pr-4"
        >
          <vs-textarea
            label="Core skill reflection"
            v-model="children[activeChildIndex].coreSkillReflection"
            :disabled="true"
          />
        </vs-col>
        <vs-col
          :class="children[activeChildIndex].childVoice ? 'hasValue' : ''"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="6"
          vs-xs="12"
          class="pl-4"
        >
          <vs-textarea
            label="Child's voice"
            v-model="children[activeChildIndex].childVoice"
            :disabled="true"
          />
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-type="flex" vs-w="10">
          <h3 class="h2 mb-4">
            Observed growth in {{ activity.coreSkills[0].name }}
          </h3>
        </vs-col>
      </vs-row>
      <vs-row class="mt-8">
        <div class="range">
          <ul class="range-labels">
            <!-- <li>
              <input
                id="zero"
                type="radio"
                name="growthInSafety"
                v-model="children[activeChildIndex].growthInSafety"
                value="0"
                :disabled="true"
              />
              <label for="zero">
                <span></span>
                0
              </label>
            </li> -->
            <li>
              <input
                id="one"
                type="radio"
                name="growthInSafety"
                v-model="children[activeChildIndex].growthInSafety"
                :disabled="true"
                value="1"
              />
              <label for="one">
                <span></span>
                1
              </label>
            </li>
            <li>
              <input
                id="two"
                type="radio"
                name="growthInSafety"
                v-model="children[activeChildIndex].growthInSafety"
                :disabled="true"
                value="2"
              />
              <label for="two">
                <span></span>
                2
              </label>
            </li>
            <li>
              <input
                id="three"
                type="radio"
                name="growthInSafety"
                v-model="children[activeChildIndex].growthInSafety"
                :disabled="true"
                value="3"
              />
              <label for="three">
                <span></span>
                3
              </label>
            </li>
            <li>
              <input
                id="four"
                type="radio"
                name="growthInSafety"
                v-model="children[activeChildIndex].growthInSafety"
                :disabled="true"
                value="4"
              />
              <label for="four">
                <span></span>
                4
              </label>
            </li>
            <li>
              <input
                id="five"
                type="radio"
                name="growthInSafety"
                v-model="children[activeChildIndex].growthInSafety"
                :disabled="true"
                value="5"
              />
              <label for="five">
                <span></span>
                5
              </label>
            </li>
          </ul>
        </div>
      </vs-row>
      <vs-row>
        <div class="m-10"></div>
      </vs-row>
    </vx-card>
    <div id="children-follow-up"></div>
    <vx-card v-if="children.length">
      <div class="flex mb-5">
        <h3 class="h2 mb-0">Follow Up Activity</h3>
      </div>
      <div class="overflow-auto">
        <table
          class="table border-none follow-activity-table"
          width="100%"
          v-if="children[activeChildIndex].followUps.length > 0"
        >
          <template
            v-for="(followUp, fKey) in children[activeChildIndex].followUps"
          >
            <tr v-bind:key="fKey + 0.11">
              <td width="40%">
                <!-- <strong class="block">Activity {{ fKey + 1 }} :</strong> -->
                <strong class="block mb-2">{{ followUp.name }}</strong>
                <p>{{ followUp.description }}</p>
              </td>
              <!-- <td width="30%">{{ followUp.description }}</td> -->
              <td width="10%" class="text-center">
                <strong class="block mb-5">Core skill</strong>
                <img
                  v-if="followUp.coreSkills"
                  :src="followUp.coreSkills[0].icon"
                  alt
                  class="inline-block h-12 object-contain"
                />
                <span class="block">{{
                  followUp.coreSkills ? followUp.coreSkills[0].name : ""
                }}</span>
              </td>
              <td width="10%" class="text-center">
                <strong class="block mb-5">Way of Learning</strong>
                <img
                  v-if="followUp.waysOfLearnings"
                  :src="followUp.waysOfLearnings[0].icon"
                  alt
                  width="45px"
                  height="45px"
                  class="inline-block"
                  style="object-fit: scale-down;"
                />
                <span class="block">{{
                  followUp.waysOfLearnings
                    ? followUp.waysOfLearnings[0].name
                    : ""
                }}</span>
              </td>
              <td width="10%" class="text-center">
                <strong class="block mb-5">STREAM</strong>
                <img
                  v-if="followUp.streams"
                  :src="followUp.streams[0].icon"
                  alt
                  width="45px"
                  height="45px"
                  class="inline-block"
                  style="object-fit: scale-down;"
                />
                <span class="block">{{
                  followUp.streams ? followUp.streams[0].name : ""
                }}</span>
              </td>
              <td>
                <!-- <vs-checkbox
                  @click="followUpComplete($event, followUp._id)"
                  v-model="followUp.isCompleted"
                  vs-value="1"
                ></vs-checkbox> -->
                <vs-textarea
                  :class="followUpCompletedText ? 'hasValue' : ''"
                  :label="'Complete text'"
                  v-model="followUpCompletedText"
                  name="followUpCompletedText"
                  :disabled="true"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('followUpCompletedText')"
                  >{{ errors.first("followUpCompletedText") }}</span
                >
                <!-- <vs-button
                  @click="followUpComplete(followUp._id)"
                  class="pull-right"
                >
                  {{
                    followUp.isCompleted
                      ? "Update complete text"
                      : "Complete follow up"
                  }}</vs-button> -->
              </td>
            </tr>
            <tr v-bind:key="fKey + 0.22"></tr>
          </template>
        </table>
      </div>
    </vx-card>
    <vs-row
      vs-align="flex-start"
      vs-type="flex"
      vs-justify="left"
      class="w-full"
    >
      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
        <div class="w-full m-5" align="right">
          <vs-button
            type="filled"
            @click.prevent="makeNonSpontaneous"
            color="primary"
            class="mr-5"
            v-if="activity.isSpontaneous"
            >Make normal activity
          </vs-button>
          <vs-button
            type="filled"
            @click="goBack()"
            color="success"
            class="mr-5"
            >Back
          </vs-button>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Vue from "vue";
import VueLodash from "vue-lodash";
import lodash from "lodash";
import vSelect from "vue-select";
import VueSimpleSuggest from "vue-simple-suggest";
import LightBox from "vue-image-lightbox";
import "vue-simple-suggest/dist/styles.css"; // Optional CSS
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";
import Swal from "sweetalert2/dist/sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
import Collapse from "@/views/pages/components/Collapse";

Vue.use(VueLodash, { name: "custom", lodash: lodash });

const ALLOWED_VIDEO_FILETYPES = ["mp4", "mov", "avi", "webm"];

export default {
  components: { vSelect, VueSimpleSuggest, LightBox, Collapse },
  props: ["selectedActivity", "followUpData"],
  data() {
    return {
      showForm: false,
      startTime: new Date(),
      activity: "",
      currentImageIndex: 0,
      purposeStatement: "",
      selectedChildren: [],
      childrenList: "",
      childPopup: false,
      followUpPopUp: false,
      options: [],
      selectedChecklist: [],
      lightboxMediaSource: [],
      eylfChecklist: "",
      children: [],
      toggle: true,
      isFavourite: false,
      searchText: "",
      photos: [],
      coreSkillId: "",
      name: "",
      description: "",
      waysOfLearningId: "",
      streamId: "",
      loading: false,
      followUpChild: "",
      followUpId: "",
      childKey: null,
      followUpKey: null,
      activeChildIndex: 0,
       childDocuments:[],
      activeTab: 0,
      fastCheckPopUp: false,
      childrenFastCheck: [],
      fastCheckList: [],
      fastCheckSummaryPopUp: false,
      completeChildrenFastCheck: [],
      childFastCheckId: null,
      selectedChildFastCheck: [],
      isCompleteFollowUp: 0,
      media: [],
      tagChildrenPopUp: false,
      tagChildrenOptions: [],
      taggedTo: [],
      taggedChildren: [],
      check: "Select the children ",
      roomId: "",
      currentChildrenList: [],
      collapsed: true,
      collapseAll: "",
      eylfCategories: [],
      followUpCompletedText: "",
      openLightBox:false,
    };
  },
  watch: {
    tagChildrenPopUp(res) {
      /*  if( res ) {
           this.toggle = false;
         } */
    },

    async selectedActivity(res) {
      let self = this;
      self.children = [];
      self.selectedChildren = [];
      self.activity = res;
      self.init();
    },
    searchText(res) {
      let self = this;
      self.options = self.childrenList.map(item => {
        return {
          label: item.fullName,
          value: item._id,
          photo: item.photo
        };
      });

      let data = self.options;
      let childData = [];

      for (let i = 0; i < data.length; i++) {
        if (data[i].label.includes(res)) {
          childData.push(data[i]);
        }
      }
      self.options = childData;
    }
  },
  methods: {
    ...mapActions("activity", [
      "addChildren",
      "updateActivity",
      "changeFavouriteStatus",
      "uploadImageToActivity",
      "removeImageFromActivityById",
      "fetchDocumentsByChildId",
      "fetchActivityByLikeName",
      "storeActivity",
      "deleteActivityById",
      "editFollowUpActivity",
      "editFollowUpStatus",
      "deleteFollowUp",
      "fetchActivityPhotosByActivityId"
    ]),
    ...mapActions("fastCheck", ["fetchFastChecks", "fetchRandomFastChecks"]),
    ...mapActions("eylfCategory", ["fetchEYLFCategoryWithFrameworkByCenterId"]),
    ...mapActions("teacher", [
      "saveChildFastCheck",
      "fetchChildFastCheckByChildIdAndChildFastCheckId",
      "fetchChildFastCheckByChildFastCheckId"
    ]),
    ...mapActions("child", ["fetchChildrenByRoomId", "storeTagChildren"]),
    expandCollapseAll() {
      this.collapsed = !this.collapsed;
    },
      /* *********** check video ext *************** */
      hasAllowedVideoExtension(url) {
      const extension = url.split(".").pop();
      return ALLOWED_VIDEO_FILETYPES.includes(extension);
    },

    convertVideoFileExtenion(url) {
      const thumbArray = url.split("/");
      const thumbUrl = thumbArray[4];
      let thumbIndex = null;
      if (thumbUrl.length) {
        const thumbIndexArray = thumbUrl.split(".");
        thumbIndex = thumbIndexArray[0];
      }
      return `${process.env.VUE_APP_IMAGE_URL}undefined/video-thumb/${thumbIndex}.png`;
    },


    closeSummaryPopUp() {
      let self = this;
      self.fastCheckSummaryPopUp = false;
      setTimeout(function() {
        self.$parent.getActivities();
        self.$parent.activityEditFormDisplay = false;
      }, 200);
    },
    editActivity(activity) {
      this.$emit("editActivity", activity);
    },
    showChildPopUp() {
      this.currentChildrenList = this.selectedChildren;
      this.childPopup = true;
    },
    detailPage(fastCheckPresetId, rating) {
      let routeData = this.$router.resolve({
        name: "fast-check-document",
        params: { fastCheckPresetId: fastCheckPresetId, rating: rating }
      });
      window.open(routeData.href, "_blank");
    },
    followUpComplete(followUpId) {
      if (this.followUpCompletedText) {
        let obj = new FormData();
        obj.append("isCompleted", true);
        obj.append("followUpCompletedText", this.followUpCompletedText);
        let data = {
          activityId: followUpId,
          obj: obj
        };

        this.editFollowUpStatus(data)
          .then(async c => {
            this.$parent.getActivities();
            this.children[
              this.activeChildIndex
            ].followUps[0].followUpCompletedText = this.followUpCompletedText;
            this.children[
              this.activeChildIndex
            ].followUps[0].isCompleted = true;
            this.success("Follow up has been completed.");
          })
          .catch(err => {
            this.error(err.message);
          });
      } else {
        this.error("Please enter compete text.");
      }
    },
    async openGallery(item, index) {
      let self = this;

      // Find the true index in the master `media` array for your tagging logic
      const realIndexInFullMedia = this.media.findIndex(mediaItem => mediaItem.id === item.id);
      let indexToShowInLightbox;

      // 1. Prepare the data source for the lightbox
      if (item.type === 'document') {
        this.lightboxMediaSource = [{
          id: item.id,
          src: this.getIcon(item.extension),
          thumb: this.getIcon(item.extension),
          caption: '<div style="position: absolute; left: 70%; transform: translateX(-50%); min-width: 150px; margin-top: 13px;"><a href="javascript:void(0)" class="tag-photo" id="tagPhoto">Tag Document</a></div>',
          type: 'image'
        }];
        // For a single document view, the index is always 0
        indexToShowInLightbox = 0;

      } else {
        // For images/videos, the data source is the filtered `imageVideos` array
        this.lightboxMediaSource = this.imageVideos;

        // --- FIX IS HERE ---
        // Use the `index` from the v-for loop. This is the correct
        // index for the `imageVideos` array that the lightbox is using.
        indexToShowInLightbox = index;
      }

      // 2. Set the master index used for tagging logic
      this.currentImageIndex = realIndexInFullMedia;
      this.getTaggedList(this.currentImageIndex);

      // 3. Show the lightbox and the selected item
      this.openLightBox = true;
      await this.$nextTick(); // Wait for the component to render

      if (this.$refs.lightbox) {
        this.$refs.lightbox.showImage(indexToShowInLightbox);
      }

      // 4. Bind the click event for the tagging link in the caption
      setTimeout(() => {
        const tagButton = document.getElementById('tagPhoto');
        if (tagButton) {
          tagButton.onclick = () => {
            self.tagChild();
          };
        }
      }, 500);
    },
    onImageChanged(index) {
      // Get the item from the current lightbox source using the index from the event
      const currentItem = this.lightboxMediaSource[index];
      if (!currentItem) return;

      // Find the real index of that item in your main `this.media` array by its unique ID
      const realIndex = this.media.findIndex(mediaItem => mediaItem.id === currentItem.id);

      // Update the main index used for tagging logic
      if (realIndex !== -1) {
        this.currentImageIndex = realIndex;
        this.getTaggedList(this.currentImageIndex);
      }

      // We also need to manually update the caption when the user navigates
      setTimeout(() => {
        const captionEl = document.querySelector('.vue-lb-info');
        if (captionEl) {
          const captionHTML = currentItem.caption || '';
          captionEl.innerHTML = captionHTML;
        }
      }, 150);
    },
    tagChild() {
      this.$refs["checkboxAllTag"].checked = false;
      this.$refs["checkboxAllChildren"].checked = false;
      this.tagChildrenPopUp = true;
    },
    getIcon(extension) {
      if (extension === 'pdf') {
        return require('@/assets/images/file-icons/pdf.png');
      } else {
        return require('@/assets/images/file-icons/doc.png');
      }
    },
    goBack() {
      this.$router.push({ path: "/teacher/learning-story" });
    },
    async selectChildToUpdate(child, key) {
      this.removeDocumentByChildIdFromMedia(this.children[this.activeChildIndex].childId)
      this.activeChildIndex = key;
      if (
        this.children[key].followUps &&
        this.children[key].followUps.length > 0
      ) {
        this.followUpCompletedText = this.children[
          key
        ].followUps[0].followUpCompletedText;
      } else {
        this.followUpCompletedText = "";
      }
      await this.getDocumentListByChildId(this.children[this.activeChildIndex].childId)
      this.addDocumentsToMedia();
    },
    async uploadImage(file) {
      this.$vs.loading();
      let imageFile = file;
      if (file.length > 0) {
        let obj = new FormData();

        for (let i = 0; i < imageFile.length; i++) {
          obj.append("file", imageFile[i]);
        }

        let data = {
          activityId: this.activity._id,
          obj: obj,
          config: {
            header: {
              "Content-Type": "image/png"
            }
          }
        };

        this.uploadImageToActivity(data)
          .then(async res => {
            this.photos = res.data.data;
            this.media = [];
            this.media = await this.photos.map(item => {
              return {
                id: item._id,
                thumb: item.photo,
                src: item.photo,
                caption: "Image",
                srcset: item.photo
              };
            });

            this.$vs.loading.close();
          })
          .catch(err => {
            //console.log(err);
            this.$vs.loading.close();
          });
      }
      this.$vs.loading.close();
    },
    removeImage(imageId) {
      let self = this;
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          self.$vs.loading();
          const index = lodash.findIndex(self.media, function(o) {
            return o.id === imageId;
          });
          let data = {
            activityId: self.activity._id,
            imageId: imageId
          };

          self
            .removeImageFromActivityById(data)
            .then(async result => {
              self.media.splice(index, 1);
              self.$vs.loading.close();
            })
            .catch(err => {
              self.$vs.loading.close();
            });
        }
      });
    },
    selectAllChildren(res) {
      this.toggle = !res;
      if (res) {
        this.selectedChildren = this.options;
      } else {
        this.selectedChildren = [];
      }
    },
    selectAllTagChildren(res) {
      this.toggle = !res;
      if (res) {
        this.taggedTo = this.tagChildrenOptions;
      } else {
        this.taggedTo = [];
      }
    },
    submitActivity() {
      const endTime = new Date();
      const timeTaken = (endTime.getTime() - this.startTime.getTime()) / 1000;
      let obj = new FormData();
      let childrenData = this.children.map(item => {
        return {
          childId: item.childId,
          childVoice: item.childVoice,
          coreSkillReflection: item.coreSkillReflection,
          growthInSafety: item.growthInSafety,
          howHasChanged: item.howHasChanged
        };
      });
      obj.append(
        "purposeStatement",
        this.purposeStatement ? this.purposeStatement : ""
      );
      obj.append("eylfFrameworks", this.selectedChecklist);
      obj.append("children", JSON.stringify(childrenData));
      obj.append("timeTaken", timeTaken);
      let data = {
        activityId: this.activity._id,
        obj: obj,
        config: {
          header: {
            "Content-Type": "image/png"
          }
        }
      };
      this.updateActivity(data)
        .then(async c => {
          this.activeTab = 0;

          let a = await this.fastCheckList.map(item => {
            return {
              FastCheckPresetId: item._id,
              name: item.name,
              description: item.description,
              rating: null,
              childId: this.children[this.activeTab].childId,
              fastCheckQuestionId: item.questions ? item.questions._id : null,
              question: item.questions ? item.questions.name : null
            };
          });
          this.selectedChildFastCheck = a;
          this.success("Data saved.");
          this.fastCheckPopUp = true;
        })
        .catch(err => {
          this.error(err.message);
        });
    },
    makeNonSpontaneous() {
      let self = this;
      const endTime = new Date();
      const timeTaken = (endTime.getTime() - this.startTime.getTime()) / 1000;
      let obj = new FormData();
      let childrenData = this.children.map(item => {
        return {
          childId: item.childId,
          childVoice: item.childVoice,
          coreSkillReflection: item.coreSkillReflection,
          growthInSafety: item.growthInSafety,
          howHasChanged: item.howHasChanged
        };
      });
      obj.append(
        "purposeStatement",
        this.purposeStatement ? this.purposeStatement : ""
      );
      obj.append("eylfFrameworks", this.selectedChecklist);
      obj.append("children", JSON.stringify(childrenData));
      obj.append("timeTaken", timeTaken);
      obj.append("isSpontaneous", false);
      let data = {
        activityId: this.activity._id,
        obj: obj,
        config: {
          header: {
            "Content-Type": "image/png"
          }
        }
      };

      this.updateActivity(data)
        .then(res => {
          this.$vs.notify({
            text: "Activity made normal",
            title: "Success",
            color: "success"
          });
          setTimeout(function() {
            self.$router.push({ name: "Documentation" });
          }, 1000);
        })
        .catch(err => {
          this.error(err.message);
          this.$vs.notify({
            text: "Failed to save draft",
            title: "Failed",
            color: "danger"
          });
        });
    },
    async getChildrenList(roomId) {
      await this.fetchChildrenByRoomId(roomId).then(async children => {
        this.childrenList = children.data.data;
        this.tagChildrenOptions = this.childrenList.map(item => {
          return {
            text: item.fullName,
            value: item._id,
            label: item.fullName,
            photo: item.photo
          };
        });
      });
    },
    async getTaggedList(val) {
      let self = this;
      let currentPhotoTag = self.photos[val].taggedTo;
      let taggedChildren = [];
      if (currentPhotoTag.length) {
        for (let i = 0; i < currentPhotoTag.length; i++) {
          let a = await this.lodash.filter(this.childrenList, {
            _id: currentPhotoTag[i]
          });
          a = a.map(item => {
            return {
              text: item.fullName,
              value: item._id,
              label: item.fullName,
              photo: item.photo
            };
          });
          taggedChildren.push(a[0]);
        }
      }
      self.taggedTo = taggedChildren;
    },
    async cancelTagChildren() {
      let self = this;
      self.tagChildrenPopUp = false;
    },
    async confirmTag() {
      let childrenTagged = this.taggedTo.map(item => {
        let existData = lodash.filter(this.children, { childId: item.value });
        return {
          label: item.fullName,
          photo: item.photo,
          value: item.value
        };
      });
      let b = this.taggedTo.map(item => {
        return item.value;
      });
      const info = {
        tagged: b,
        photo: this.media[this.currentImageIndex],
        activityId: this.activity._id
      };
      await this.storeTagChildren(info).then(res => {
        this.tagChildrenPopUp = false;
      });
      this.taggedChildren = [];
      setTimeout(function() {
        this.taggedChildren = childrenTagged;
      }, 300);

      await this.fetchActivityPhotosByActivityId(this.activity._id).then(
        res => {
          this.photos = res.data.data;
        }
      );
    },
    async getEylfChecklist(centerId) {
      await this.fetchEYLFCategoryWithFrameworkByCenterId(centerId).then(
        checklist => {
          this.eylfCategories = checklist.data.data.eylfCategories;
        }
      );
    },
    async cancelAddChildren() {
      let self = this;
      if (self.activity.children[0].child.length) {
        self.selectedChildren = [];
        await self.activity.children.map(item => {
          self.selectedChildren.push({
            label: item.child[0].fullName,
            photo: item.child[0].photo,
            value: item.childId
          });
        });
      }
      self.childPopup = false;
    },
    async addChildrenToActivity() {
      let self = this;
      let currentChildren = self.children.length;
      let x = lodash.difference(
        self.currentChildrenList,
        self.selectedChildren
      );
      if (self.selectedChildren.length > 20) {
        self.error("You cannot add more than 20 children to activity.");
      } else {
        self.$vs.loading();
        let childrenPush = self.selectedChildren.map(item => {
          let existData = lodash.filter(self.children, { childId: item.value });
          return {
            childId: item.value,
            howHasChanged:
              existData.length > 0 ? existData[0].howHasChanged : "",
            coreSkillReflection:
              existData.length > 0 ? existData[0].coreSkillReflection : "",
            childVoice: existData.length > 0 ? existData[0].childVoice : "",
            growthInSafety:
              existData.length > 0 ? existData[0].growthInSafety : "",
            photo: item.photo,
            name: item.label,
            followUps: existData.length > 0 ? existData[0].followUps : []
          };
        });

        let addData = childrenPush.map(item => {
          return {
            childId: item.childId,
            howHasChanged: item.howHasChanged,
            coreSkillReflection: item.coreSkillReflection,
            childVoice: item.childVoice,
            growthInSafety: item.growthInSafety
          };
        });

        let obj = {
          children: addData,
          activityId: self.activity._id
        };

        self
          .addChildren(obj)
          .then(async result => {
            await self.fetchChildrenByRoomId(self.teacher.roomId);

            if (x.length > 0) {
              let removeChild = x.map(item => {
                return item.value;
              });
              let y = {
                parentActivityId: self.activity._id,
                child: removeChild
              };
              await self.deleteFollowUp(y);
            }
            if (currentChildren > 0) {
              this.success("Data Updated");
            } else {
              this.success("Data Added");
            }
            self.$parent.getActivities();
            self.children = [];
            self.$vs.loading.close();

            setTimeout(function() {
              self.children = childrenPush;
            }, 300);
          })
          .catch(err => {
            this.error(err.message);
            self.$vs.loading.close();
          });
        self.childPopup = false;
        self.$vs.loading.close();

        this.$vs.loading.close();
      }
    },
    /*Favourite status update*/
    async updateFavouriteStatus() {
      this.$vs.loading();
      this.changeFavouriteStatus(this.activity._id)
        .then(async result => {
          this.isFavourite = await result.data.data.isFavourite;
          this.success(
            this.isFavourite === true
              ? "Activity has been added to Favorite List."
              : "Activity has been removed from Favorite List"
          );
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.loading.close();
          this.error(err.message);
        });
    },
    async init() {
      let self = this;
      self.isFavourite = self.activity.isFavourite;
      self.photos = self.activity.photos;
      self.roomId = self.activity.roomId;
      if(self.roomId){
      await self.getChildrenList(self.roomId);
      }
      self.getEylfChecklist(self.teacher.learningCenterId);
      self.purposeStatement = self.activity.purposeStatement;
      self.selectedChecklist = self.activity.eylfFrameworks;
      self.completeChildrenFastCheck = [];
      self.options = self.childrenList.map(item => {
        return {
          label: item.fullName,
          value: item._id,
          photo: item.photo
        };
      });

      self.media = self.photos.map(item => {
        if (this.hasAllowedVideoExtension(item.photo)) {
          const thumbnail = this.convertVideoFileExtenion(item.photo);
          return {
            // For video
            id: item._id,
            type: "video",
            thumb: thumbnail,
            src: item.photo,
            sources: [
              {
                src: item.photo,
                type: "video/mp4"
              }
            ],
            caption:
              '<a href="javascript:void(0)" class="tag-photo" id="tagPhoto">Tag Photo and Video</a>',
            autoplay: false,
            taggedTo: item.taggedTo || [],
            activityId:self.activity._id
          };
        } else {
          const extension = item.isDocument ? item.photo.split('.').pop() : '';
          return {
            id: item._id,
            thumb: item.photo,
            src: item.photo,
            title: item.title || extension,
            type: item.isDocument ? "document" : "image",
            extension: extension,
            caption: item.isDocument
              ? '<a href="javascript:void(0)" class="tag-photo" id="tagPhoto">Tag Document</a>'
                : '<a href="javascript:void(0)" class="tag-photo" id="tagPhoto">Tag Photo and Video</a>',
            srcset: item.photo,
            taggedTo: item.taggedTo || [],
            activityId:self.activity._id
          };
        }
      });
      self.media = self.media.filter(item=>!item.isDocument);
      if (self.activity.children[0].child.length) {
        self.children = await self.activity.children.map(item => {
          return {
            childId: item.childId,
            howHasChanged: item.howHasChanged,
            coreSkillReflection: item.coreSkillReflection,
            childVoice: item.childVoice,
            growthInSafety: item.growthInSafety,
            photo: item.child[0].photo,
            name: item.child[0].fullName,
            followUps: item.followUp
          };
        });

        self.activity.children.map(item => {
          self.selectedChildren.push({
            label: item.child[0].fullName,
            photo: item.child[0].photo,
            value: item.childId
          });
        });
        if (
          self.children.length > 0 &&
          self.children[0].followUps &&
          self.children[0].followUps.length > 0
        ) {
          self.followUpCompletedText =
            self.children[0].followUps[0].followUpCompletedText;
        }
      }
      if (self.followUpData) {
        self.selectFollowUpChild(self.followUpData);
      }
      await self.getDocumentListByChildId(this.children[this.activeChildIndex].childId)
      self.addDocumentsToMedia();
    },
    addChildFollowUp(res, key) {
      let self = this;
      self.followUpChild = res;
      self.followUpPopUp = true;
    },
      addDocumentsToMedia() {
  if (!this.childDocuments.length) return;

  let documentsChild = [];

  this.childDocuments.forEach((item) => {
    item.photos.forEach((doc) => {
      const extension = doc.isDocument ? doc.photo.split(".").pop() : "";
      documentsChild.push({
        id: doc._id,
        thumb: doc.photo,
        src: doc.photo,
        title: doc.title || extension,
        type: doc.isDocument ? "document" : "image",
        extension,
        caption: doc.isDocument
          ? '<a href="javascript:void(0)" class="tag-photo" id="tagPhoto">Tag Document</a>'
          : '<a href="javascript:void(0)" class="tag-photo" id="tagPhoto">Tag Photo and Video</a>',
        srcset: doc.photo,
        taggedTo: doc.taggedTo || [],
        activityId: item._id,
      });
    });
  });

  // Merge & remove duplicate documents by `id`
  const allMedia = [...this.media, ...documentsChild];

  this.media = Array.from(
    new Map(allMedia.map((item) => [item.id, item]))
  ).map(([_, value]) => value);
},
    removeDocumentByChildIdFromMedia(childId){
    this.media = this.media.filter((mediaItem)=>{
      return !mediaItem.taggedTo.includes(childId)
    })
    },
     getDocumentListByChildId(childId){
      this.childDocuments = [];
      return new Promise(async (resolve, reject) => {
      await this.fetchDocumentsByChildId(childId).then((response) => {
            const jsondata = JSON.stringify(response.data.data);
            const parsed = JSON.parse(jsondata);
            const result = [];
            this.childDocuments = parsed;
            resolve(result);
      
      }).catch((error) => {
           console.log(error);
           reject(error);
      });
    })},
    /*suggestion title*/
    getList(inputValue) {
      return new Promise(async (resolve, reject) => {
        await this.fetchActivityByLikeName(inputValue)
          .then(response => {
            const jsondata = JSON.stringify(response.data.data);
            const parsed = JSON.parse(jsondata);
            const result = [];
            parsed.forEach(searchResult => {
              result.push({
                id: searchResult._id,
                title: searchResult.name,
                description: searchResult.description,
                link: ""
              });
            });
            resolve(result);
          })
          .catch(error => {
            this.loading = false;
            reject(error);
          });
      });
    },
    onSuggestSelect(suggest) {
      this.selected = suggest.title;
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      let result = this.$refs.suggestComponent.displayProperty(
        suggestion.title
      );
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [""];
      return result.replace(
        new RegExp("(.*?)(" + texts.join("|") + ")(.*?)", "gi"),
        "$1<b>$2</b>$3"
      );
    },
    /*Add Follow up*/
    submitFollowUp() {
      this.$vs.loading();
      this.$validator.validateAll().then(async result => {
        if (result) {
          let obj = new FormData();

          if (this.followUpId === "") {
            obj.append("childId", this.followUpChild.childId);
            obj.append("parentActivityId", this.activity._id);
            obj.append("learningCenterId", this.teacher.learningCenterId);
            obj.append("roomId", this.teacher.roomId);
            obj.append("teacherId", this.teacher._id);
          }

          obj.append("name", this.name);
          obj.append("description", this.description);
          obj.append("coreSkills", this.coreSkillId);
          obj.append("waysOfLearnings", this.waysOfLearningId);
          obj.append("stream", this.streamId);

          let data = {
            obj: obj,
            config: {
              header: {
                "Content-Type": "image/png"
              }
            }
          };

          if (this.followUpId) {
            data.activityId = this.followUpId;
            await this.editFollowUpActivity(data)
              .then(async c => {
                this.$vs.loading.close();
                this.children[this.activeChildIndex].followUps[
                  this.followUpKey
                ] = await c.data.data;
                this.followUpPopUp = false;
                this.initValues();
                this.followUpId = "";
                this.$parent.getActivities();
                this.success("Follow Up has been updated.");
                this.errors.clear();
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              })
              .catch(err => {
                this.$vs.loading.close();
                this.followUpChild = false;
                this.error(err.message);
              });
          } else {
            await this.storeActivity(data)
              .then(async c => {
                this.children[this.activeChildIndex].followUps.push(
                  c.data.data
                );
                this.$vs.loading.close();
                this.followUpPopUp = false;
                this.initValues();
                this.$parent.getActivities();

                this.success("Follow Up has been added.");
                await this.fetchChildrenByRoomId(this.teacher.roomId);

                this.errors.clear();
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              })
              .catch(err => {
                this.followUpId = "";
                this.$vs.loading.close();
                this.followUpChild = false;
                this.error(err.message);
              });
          }
        } else {
          this.$vs.loading.close();
        }
      });
    },
    /*form value empty*/
    initValues() {
      this.coreSkillId = "";
      this.waysOfLearningId = "";
      this.name = "";
      this.description = "";
      this.streamId = "";
      this.followUpId = "";
    },
    /*Follow up remove*/
    async removeFollowUp(activityId, fKey) {
      this.$vs.loading();
      await this.deleteActivityById(activityId)
        .then(async result => {
          this.$delete(this.children[this.activeChildIndex].followUps, fKey);

          this.$vs.loading.close();
          this.success("Follow up has been removed.");
          this.followUpId = "";
        })
        .catch(err => {
          this.followUpId = "";
          this.$vs.loading.close();
          this.error("Follow up could not be removed.");
        });
    },
    /*edit follow form value display*/
    editFollowUp(activity, fKey) {
      this.coreSkillId = activity.coreSkills[0]._id;
      this.waysOfLearningId = activity.waysOfLearnings[0]._id;
      this.name = activity.name;
      this.description = activity.name;
      this.streamId = activity.streams[0]._id;
      this.followUpId = activity._id;
      this.followUpKey = fKey;
      this.followUpPopUp = true;
    },
    /*Get Fast Check List*/
    async getFastCheck() {
      await this.fetchRandomFastChecks(this.teacher.room.ageGroup).then(
        async result => {
          this.fastCheckList = result.data.data;
        }
      );
    },
    async nextPrevious(value) {
      this.$vs.loading();

      let fastCheckData = this.selectedChildFastCheck.map(item => {
        return {
          roomId: this.teacher.roomId,
          childId: item.childId,
          FastCheckPresetId: item.FastCheckPresetId,
          teacherId: this.teacher._id,
          activityId: this.selectedActivity._id,
          rating: item.rating,
          fastCheckQuestionId: item.fastCheckQuestionId,
          lastIndex: this.activeTab === this.children.length - 1 && value !== -1
        };
      });
      await this.saveChildFastCheck(fastCheckData)
        .then(async response => {
          this.childFastCheckId = response.data.data.childFastCheckId;

          if (this.activeTab === this.children.length - 1 && value !== -1) {
            await this.fetchChildFastCheckByChildFastCheckId(
              this.childFastCheckId
            )
              .then(result => {
                this.activeTab = 0;
                this.completeChildrenFastCheck = result.data.data;
                this.$vs.loading.close();
              })
              .catch(err => {/* console.log(err) */});

            this.$vs.loading.close();
            this.fastCheckSummaryPopUp = true;
            this.fastCheckPopUp = false;
          } else {
            this.activeTab = this.activeTab + value;
            let obj = {
              childId: this.children[this.activeTab].childId,
              childFastCheckId: this.childFastCheckId
            };

            await this.fetchChildFastCheckByChildIdAndChildFastCheckId(
              obj
            ).then(response => {
              let data = response.data.data;

              if (data.length > 0) {
                this.selectedChildFastCheck = data.map(item => {
                  return {
                    name: item.preset.length > 0 ? item.preset[0].name : "",
                    description:
                      item.preset.length > 0 ? item.preset[0].description : "",
                    rating: item.rating,
                    childId: item.childId,
                    FastCheckPresetId: item.FastCheckPresetId,
                    fastCheckQuestionId: item.fastCheckQuestionId,
                    question: item.question.name
                  };
                });
              } else {
                this.selectedChildFastCheck = this.selectedChildFastCheck.map(
                  item => {
                    return {
                      name: item.name,
                      description: item.description,
                      rating: null,
                      childId: this.children[this.activeTab].childId,
                      FastCheckPresetId: item.FastCheckPresetId,
                      fastCheckQuestionId: item.fastCheckQuestionId,
                      question: item.question
                    };
                  }
                );
              }
              this.$vs.loading.close();
              document
                .getElementById("fast-scroll-top")
                .scrollIntoView({ block: "start" });
            });
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    /*Success notify*/
    success(message = "Data Saved") {
      this.$vs.notify({
        title: "Success",
        text: message,
        color: "success",
        iconPack: "feather",
        position: "top-right",
        icon: "icon-check-circle"
      });
    },
    /*error notify*/
    error(message = "Task Failed") {
      this.$vs.notify({
        title: "Error",
        text: message,
        color: "danger",
        iconPack: "feather",
        position: "top-right",
        icon: "icon-times"
      });
    },
    updateActiveTabKey(value) {
      this.activeTab = value;
    },
    selectFollowUpChild(activity) {
      this.activeChildIndex = lodash.findIndex(this.children, function(o) {
        return (
          o.childId ==
          (Array.isArray(activity.children)
            ? activity.children[0].childId
            : activity.children.childId)
        );
      });
    }
  },
  async mounted() {
    let $this = this;
    setTimeout(function() {
      document.getElementById("tagPhoto").onclick = function() {
        $this.tagChild();
      };
    }, 1000);

    let self = this;
    self.selectedChildren = [];
    self.activity = self.selectedActivity;
    self.init();
  },
  created() {
    this.getFastCheck();
    this.getChildrenList(this.selectedActivity.roomId);
  },
  computed: {
    teacher() {
      return this.$store.state.AppActiveUser;
    },
    documents() {
      return this.media.filter(
        (d) =>
          d.type === "document" &&
          this.children.length && d.taggedTo.includes(this.children[this.activeChildIndex].childId)
      );
    },
    imageVideos() {
      return this.media.filter(d => d.type !== 'document');
    },
    coreSkills() {
      return this.$store.state.coreSkill.coreSkills;
    },
    streams() {
      return this.$store.state.stream.streams;
    },
    waysOfLearningList() {
      return this.$store.state.waysOfLearning.waysOfLearning;
    }
  }
};
</script>
<style lang="scss">
.vs-popup {
  min-height: 300px;
}
video {
  max-width: 100%;
  height: 700px;
  &.video-slider {
    height: 100px;
  }
}
.photo-item {
  margin-right: 10px;
  text-align: center;
  position: relative;
}
.playButton {
  object-fit: contain !important;
  margin: 0;
  text-align: center;
  position: absolute;
  width: 96px;
  height: 96px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.eylf-card {
  .eylf-col {
    border-bottom: 1px solid #e7e7e7;
    border-right: 1px solid #e7e7e7;
    padding-right: 30px;
    padding-left: 20px;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      border-right: none;
    }

    @media (max-width: 900px) {
      border-right: none;
      margin-right: 0;
    }
    @media (max-width: 1200px) {
      .mr-8 {
        margin-right: 10px !important;

        .con-vs-checkbox {
          margin-top: 5px;
        }
      }
    }
    @media (max-width: 900px) {
      border-right: none;
      .mr-8 {
        margin-right: 10px !important;

        .con-vs-checkbox {
          margin-top: 5px;
        }
      }
    }
  }

  p {
    font-size: 16px;
    line-height: 22px;
    color: #5e5e5e;
  }
}

.con-img-upload {
  padding-bottom: 50px;

  .img-upload {
    margin: 0 15px 15px 0;
  }
}

.con-input-upload {
  background: none;
  border: 2px solid #2d9ad5;
  border-radius: 5px;
  width: auto;
  height: auto;
  margin: 0;
  padding: 10px 20px;
  min-height: 42px;
  min-width: 150px;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  bottom: 0;
  left: 5px;
}

.con-input-upload {
  .vs-upload--button-upload {
    display: none;
  }
}

.con-input-upload {
  .text-input {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    line-height: 19px;
    color: #2d9ad5;
    font-weight: 600;
    z-index: -1;
    min-width: auto;
  }
}

.add-children-popup,
.tag-children-popup {
  .vs-popup {
    @media (min-width: 992px) {
      width: 825px;
    }
  }

  .vs-popup--header {
    height: 0;
  }

  .vs-popup--close {
    transform: none !important;
    background: none !important;
    box-shadow: none;
    position: relative;
    top: 35px;
    right: 20px;
    font-size: 25px;
    color: #2b2d3d;

    &:hover {
      color: #2d9ad5;
    }
  }

  .vs-popup--content {
    padding: 45px 35px !important;
    margin: 0;
    width: 100%;

    .vx-card {
      box-shadow: none;

      .vx-card__body {
        // padding: 10px !important;
        border-radius: 8px !important;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.11);

        .vs-con-input-label.is-label-placeholder {
          margin-top: 0 !important;
          margin-bottom: 25px;
        }
      }
    }
  }

  .vs-checkbox-primary {
    .vs-checkbox {
      width: 20px !important;
      height: 20px !important;
      border: 1px solid #289ad5 !important;
      border-radius: 50%;
      display: flex;
      align-items: center;
      overflow: hidden;
      transform: none;
    }
  }

  .round {
    label {
      cursor: pointer;
      position: absolute;
      width: 20px;
      height: 20px;
      border: 1px solid #289ad5 !important;
      border-radius: 50%;
      display: flex;
      align-items: center;
      transform: none;
      margin: 0 5px;
      background: transparent;
      transition: 0.4s all ease-in-out;

      i {
        opacity: 0;
      }
    }
  }
}

.add-children-popup {
  .vs-checkbox-primary {
    .vs-checkbox {
      margin-right: 5px;
      border: none !important;

      .vs-checkbox--check {
        border: 1px solid #2d9ad5 !important;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        transform: none;
        transition: 0.4s all ease-in-out;
      }

      .vs-icon {
        opacity: 0;
      }
    }
  }
}

.add-children-popup
  .vs-checkbox--input:checked
  + .vs-checkbox
  .vs-checkbox--check {
  transform: none;
  top: 0;
  left: 0;
  border: 10px solid #2d9ad5 !important;
  width: 100%;
  height: 100%;
  animation: shrink-bounce 200ms cubic-bezier(0.4, 0, 0.23, 1);
}

.add-children-popup .vs-checkbox--input:checked + .vs-checkbox .vs-icon {
  transform: none;
  opacity: 1;
}

.add-children-popup ul li {
  display: flex;
  align-items: center;
  margin: 10px 0;
}

.add-children-popup .vs-checkbox-primary .con-slot-label {
  margin-left: 6px;
  font-size: 16px;
  line-height: 22px;
}

.round {
  position: relative;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  border: 10px solid #2898d5 !important;
  animation: shrink-bounce 200ms cubic-bezier(0.4, 0, 0.23, 1);
}

.round input[type="checkbox"]:checked + label i {
  opacity: 1;
  position: relative;
  top: 1px;
  left: -10px;
  font-size: 20px;
  color: #ffffff;
  transform: none;
}

@keyframes shrink-bounce {
  0% {
    transform: scale(1);
  }
  33% {
    transform: scale(0.85);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes checkbox-check {
  0% {
    width: 0;
    height: 0;
    border-color: #212121;
    transform: translate3d(0, 0, 0) rotate(45deg);
  }
  33% {
    width: 0.2em;
    height: 0;
    transform: translate3d(0, 0, 0) rotate(45deg);
  }
  100% {
    width: 0.2em;
    height: 0.5em;
    border-color: #212121;
    transform: translate3d(0, -0.5em, 0) rotate(45deg);
  }
}

@mixin rangeThumb {
  width: 18px;
  height: 18px;
  margin: -8px 0 0;
  border-radius: 50%;
  background: #37adbf;
  cursor: pointer;
  border: 0 !important;
  position: relative;
  z-index: 1;
}

@mixin rangeTrack {
  width: 100%;
  height: 4px;
  cursor: pointer;
  background: grey;
}

.range {
  position: relative;
  width: 900px;
  height: 5px;
}

.range input[type="radio"] {
  border: 13.5px solid #2898d5;
  border-radius: 50%;
  width: 27px;
  position: absolute;
  height: 27px;
  -webkit-appearance: none;
  top: -12px;
  right: -12px;
  transition: 0.4s all ease-in-out;
  z-index: 1;
  opacity: 0;

  &:checked {
    opacity: 1;
  }
}

// Labels below slider
.range-labels {
  background: #f0f0f0;
  height: 6px;
  border-radius: 3px;
  padding: 0;
  list-style: none;

  li {
    display: inline-block;
    position: relative;
    width: calc(100% / 4);
    text-align: left;
    color: black;
    font-size: 14px;
    height: 6px;
    top: -9px;
    cursor: pointer;

    &:first-child {
      width: 0;
    }

    &::before {
      content: "";
      position: absolute;
      top: -4px;
      right: 0;
      width: 3px;
      height: 13px;
      background: #606060;
    }

    label {
      position: absolute;
      top: 20px;
      right: -2px;
    }
  }

  .active {
    color: #37adbf;
  }

  .selected::before {
    background: #37adbf;
  }

  .selected::after {
    background: #37adbf;
  }

  .active.selected::before {
    display: none;
  }
}

.learning-activity-table {
  tr {
    th {
      padding: 10px 30px;

      &:nth-child(1) {
        width: 305px;
      }

      &:nth-child(2) {
        width: 780px;
      }

      &:nth-child(3),
      &:nth-child(4) {
        width: 180px;
      }

      &:nth-child(5) {
        width: 250px;
      }

      @media (max-width: 480px) {
        padding: 10px 15px;
      }
    }

    td {
      padding: 10px 30px;
      @media (max-width: 480px) {
        // padding: 15px;
      }
    }
  }
}

.con-vs-slider {
  z-index: 1;
}

.vs-slider--circle {
  background: #289ad5;
}

.range-labels li::before {
  z-index: 1;
}

.textarea1 {
  @media (max-width: 600px) {
    .vs-xs-12 {
      margin-bottom: 0 !important;
    }
  }
}

.textarea2 {
  @media (max-width: 600px) {
    .vs-xs-12 {
      padding: 0 !important;
    }
  }
}

.photo-wrapper {
  .vs-button {
    display: inline-block;
    margin-top: 20px;
  }
}

.vue-lb-figure {
  padding-bottom: 20px;
  line-height: 0;
}

.vue-lb-footer {
  padding: 0;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.vue-lb-info {
  background: none;
  position: absolute;
  left: 0;
  bottom: 8px;
  text-align: left;
  height: auto;
  z-index: 1;

  a {
    font-weight: 700;
    text-decoration: underline;
    color: #50c1ff;
  }
}

.follow-activity-table {
  .text-large {
    font-size: 20px;
    margin-right: 10px;
  }

  tr {
    td {
      vertical-align: top;
      padding: 10px 30px;

      &:first-child {
        padding: 10px 30px;
      }
    }
  }
}

.tag-children-popup {
  .vs-popup--title {
    visibility: hidden;
  }

  .vs-popup {
    min-height: 500px;

    p {
      font-size: 16px;
      line-height: 30px;
      margin-bottom: 5px;
    }

    .con-select {
      .vs-select--input {
        padding: 20px;
        border: 1px solid #838383;
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
}

.vs-select-primary .vs-select--item {
  font-size: 16px;
  padding: 10px;

  span {
    font-size: 16px;
    line-height: 25px;
  }

  .vs-select--item-icon {
    font-size: 30px;
  }

  &.activex {
    padding-left: 40px;
  }
}

.vs-collapse {
  .vs-component {
    align-items: flex-start;
  }
}

.vs-collapse-item {
  border: none;
  margin-bottom: 30px;
  padding-right: 30px;

  .vs-collapse-item--header {
    padding: 0;

    .con-vs-checkbox {
      align-items: flex-start;
      min-width: 60px;
    }

    .icon-header {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: #2d99d3;
      color: #fff;
      right: -60px;
      top: 15px;

      .vs-icon {
        font-size: 0;
        position: relative;
        width: 100%;
        height: 100%;

        &:before {
          content: "\e8b1";
          font-family: feather;
          font-size: 20px;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .vs-collapse-item--content {
    .con-content--item {
      padding-left: 0 !important;
    }
  }

  &.open-item {
    .vs-collapse-item--header {
      .icon-header {
        .vs-icon {
          &:before {
            content: "\e897";
          }
        }
      }
    }
  }
}

.sticky {
  margin: -30px -30px 0;
  padding: 30px 30px 0;
  top: 0;
  z-index: 10;
  background: #ffffff;
}

.vuesax-app-is-ltr .vs-input--icon {
  font-size: 2rem;
  top: auto;
  left: 10px;
}
</style>
